import styled from 'styled-components/macro';

export const Container = styled.div`
    margin-bottom: 0px;
`;
